import { render, staticRenderFns } from "./ModalCatedra.vue?vue&type=template&id=1f6f93e4&"
import script from "./ModalCatedra.vue?vue&type=script&lang=js&"
export * from "./ModalCatedra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports